const USERCODE = [
    { key: 1, title: "組合員" },
    { key: 2, title: "営業員" },
    { key: 3, title: "管理者" },
];

const USERTAB = 
   { 
      UNION_MEMBER : 1 ,
      SALE_MEMBER : 2 ,
      ADMIN : 3 
    };

const USERTABID = 
   { 
      UNION_MEMBER : 0 ,
      SALE_MEMBER : 1 ,
      ADMIN : 2 
    };


const ADMINCOUNT = 1;
  
export { USERCODE };
export { USERTAB };
export { ADMINCOUNT };
export { USERTABID };